var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6949 11.1376L14.6101 13.4025L15.42 13.0753L14.1568 9.94862L11.0793 11.192L11.4275 12.0537L13.6949 11.1376Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41012 4.40972L5.57461 6.70527L6.39551 7.00406L7.54888 3.8352L4.42993 2.7L4.11207 3.5733L6.41012 4.40972Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75913 5.3501V9.06751H11.2047V9.99687H7.88554V5.3501H8.75913Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7739 13.5576C11.6454 14.6861 10.1452 15.3075 8.54937 15.3075C6.95353 15.3075 5.45329 14.6861 4.32479 13.5576C3.19629 12.4291 2.57495 10.9289 2.57495 9.33304C2.57495 7.73721 3.19629 6.23697 4.32479 5.10847C5.02705 4.40622 5.87325 3.90036 6.79687 3.61841L7.19517 4.47718C5.0714 5.07029 3.50873 7.02277 3.50873 9.33304C3.50873 12.1123 5.77016 14.3737 8.54937 14.3737C10.9028 14.3737 12.8849 12.7521 13.437 10.5678H14.3968C14.1617 11.6926 13.6055 12.726 12.7739 13.5576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.378a74e5f6ff48fe22ec3433bd8628a1.svg";
export { ForwardRef as ReactComponent };